import "./HowItWorks.scss";

import { Box, Grid, isWidthDown, Typography, withWidth } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";

import Step1 from "../../assets/images/howitworks1.png";
import Step2 from "../../assets/images/howitworks2.png";
import Step3 from "../../assets/images/howitworks3.png";
import Bond from "../../assets/images/howitworksbond.png";
import BondRotated from "../../assets/images/howitworksbondrotated.png";

const HowItWorks = ({ width } : any) => {
  // Hooks
  const { t } = useTranslation();

  const isMobile = isWidthDown(
    "md",
    width
  );

  return (
    <Grid container spacing={8} item className="how-it-works">
      <Grid item className="header-box grid-container">
        <Typography className="header">
          {t("How it works?")}
        </Typography>
      </Grid>

      <Grid container spacing={4} direction={isMobile ? "column" : "row"} item>
        <Grid item xs={12}>
          <Box className="step-images-box" flexDirection={isMobile ? "column" : "row"}>
            <Grid container direction="row">
              <Grid item xs={6}>
                <img src={Step1} alt="step1" className="step-image"/>
              </Grid>

              {isMobile &&
              <Grid item xs={6}>
                <Typography className="step-description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc et nisi in metus vehicula maximus at nec purus.
                </Typography>
              </Grid>
              }
            </Grid>

            <Grid container direction="row">
              <Grid item xs={6} className="grid-container">
                <img src={isMobile ? BondRotated : Bond} alt="step1" className="step-image" />
              </Grid>

              {isMobile &&
              <Grid item/>
              }
            </Grid>

            <Grid container direction="row">
              <Grid item xs={6}>
                <img src={Step2} alt="step1" className="step-image" />
              </Grid>

              {isMobile &&
              <Grid item xs={6}>
                <Typography className="step-description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc et nisi in metus vehicula maximus at nec purus. In eget rhoncus lectus. Cras a dolor placerat justo porta luctus.
                </Typography>
              </Grid>
              }
            </Grid>

            <Grid container direction="row">
              <Grid item xs={6} className="grid-container">
                <img src={isMobile ? BondRotated : Bond} alt="step1" className="step-image" />
              </Grid>

              {isMobile &&
              <Grid item/>
              }
            </Grid>

            <Grid container direction="row">
              <Grid item xs={6}>
                <img src={Step3} alt="step1" className="step-image" />
              </Grid>

              {isMobile &&
              <Grid item xs={6}>
                <Typography className="step-description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc et nisi in metus vehicula maximus at nec purus.
                </Typography>
              </Grid>
              }
            </Grid>
          </Box>
        </Grid>

        {!isMobile &&
        <Grid container direction={isMobile ? "column" : "row"} spacing={4} item>
          <Grid item xs={4}>
            <Typography className="step-description">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc et nisi in metus vehicula maximus at nec purus.
            </Typography>
          </Grid>

          <Grid item xs={4}>
            <Typography className="step-description">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc et nisi in metus vehicula maximus at nec purus. In eget rhoncus lectus. Cras a dolor placerat justo porta luctus.
            </Typography>
          </Grid>

          <Grid item xs={4}>
            <Typography className="step-description">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc et nisi in metus vehicula maximus at nec purus.
            </Typography>
          </Grid>
        </Grid>
        }
      </Grid>
    </Grid>
  );
}

export default withWidth()(HowItWorks);